import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-alerta',
  templateUrl: './modal-alerta.component.html',
  styleUrl: './modal-alerta.component.scss',
})
export class ModalAlertaComponent implements AfterViewChecked {
  @Input() titulo = 'Alerta';
  @Input() contenido = 'Mensaje';
  @Input() tipo: 'confirmacion' | 'exito' | 'advertencia' | 'error' =
    'confirmacion';
  @Input() continuar = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() submitEvent = new EventEmitter<void>();

  @ViewChild('modalButton') button?: ElementRef;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewChecked() {
    setTimeout(() => {
      this.button?.nativeElement.click();
    }, 200);
  }

  confirmar() {
    this.elementRef.nativeElement.remove();
    this.submitEvent.emit();
  }

  cancelar() {
    this.elementRef.nativeElement.remove();
    this.closeEvent.emit();
  }
}
